/* From Victory — header search overlay with predictive results.
   Falls back to the /search page without JS (the toggle is a link). */

(function () {
  'use strict';

  function init() {
    var toggle = document.querySelector('[data-search-toggle]');
    var overlay = document.querySelector('[data-search-overlay]');
    if (!toggle || !overlay) return;

    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var lastFocus = null;
    var debounceTimer = null;
    var controller = null;

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        input.focus();
      });
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      results.innerHTML = '';
      input.value = '';
      if (lastFocus) lastFocus.focus();
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      overlay.hidden ? open() : close();
    });

    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
    var closeBtn = overlay.querySelector('[data-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    function fetchResults(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var url =
        root +
        'search/suggest?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-predictive-results]');
          results.innerHTML = fresh ? fresh.outerHTML : '';
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchResults(term);
      }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
